import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Login from "../../sections/Login/Login";
import Paragraph from "../common/Typography/Paragraph";
import { SignUp as SignUpRegister } from "../../sections/SignUp/SignUp";
import SecondaryHeading from "../common/Typography/SecondaryHeading";
import SpecialText from "../common/Typography/SpecialText";
import AboriginalFlag from "../../assets/img/Australian_Aboriginal.png";
import TorresStraitFlag from "../../assets/img/Torres_Strait_Islanders.png";
import AuxiliaryText from "../common/Typography/AuxiliaryText";
import { useLoginActionService } from "../../services/LoginActionService";

const FOOTER_COLUMNS = [
  {
    key: "platform",
    title: "Platform",
    links: [
      { label: "About", to: "/about-us" },
      { label: "Blog", to: "/blogs" },
      { label: "Careers", to: "#" },
      { label: "Contact", to: "/contactus" },
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Terms of Use", to: "/terms-&-conditions" },
      { label: "Site Map", to: "#" },
    ],
  },
  {
    key: "customers",
    title: "Customers",
    links: [
      { label: "For Customers", to: "/customer-support-centre" },
      { label: "Request a Quote" },
      { label: "Browse Services", to: "/category" },
      { label: "Contact a Business" },
      { label: "Leave a Review" },
      { label: "Customer FAQs", to: "/customer-support-centre#customer-faqs" },
    ],
  },
  {
    key: "businesses",
    title: "Businesses",
    links: [
      { label: "For Businesses", to: "/business-support-centre" },
      { label: "Pricing", to: "/pricing" },
      { label: "Upgrade to Pro", to: "/pro" },
      { label: "Licensing & Compliance", to: "/licensing" },
      { label: "Business FAQs", to: "/business-support-centre#business-faqs" },
    ],
  },
  {
    key: "popularServices",
    title: "Popular Services",
    links: [
      {
        label: "Air Conditioning & Heating",
        to: "/services-guide/air-conditioning-and-heating",
      },
      {
        label: "Bricklaying & Blockwork",
        to: "/services-guide/bricklaying-and-blockwork",
      },
      { label: "Cabinet Making", to: "/services-guide/cabinet-making" },
      { label: "Carpentry", to: "/services-guide/carpentry" },
      { label: "Caulking", to: "/services-guide/caulking-services" },
      { label: "Cladding & Panels", to: "/category/cladding" },
      { label: "Cleaning", to: "/services-guide/cleaning-services" },
    ],
  },
  {
    key: "resources",
    title: "Resources",
    links: [
      { label: "Help Centre", to: "/HelpCentre" },
      { label: "Services Guide", to: "/services-guide" },
      { label: "Council Regulations", to: "/councils-regulations" },
      { label: "Cost Estimates", to: "/cost-estimation" },
      { label: "Trades Poster Basics", to: "/trades-poster-basics" },
    ],
  },
  {
    key: "popularLocations",
    title: "Popular Locations",
    links: [
      { label: "Sydney", to: "/Services/available-categories-in-the-selected-city" },
      { label: "Melbourne", to: "/Services/available-categories-in-the-selected-city" },
      { label: "Brisbane", to: "/Services/available-categories-in-the-selected-city" },
      { label: "Perth", to: "/Services/available-categories-in-the-selected-city" },
      { label: "Adelaide", to: "/Services/available-categories-in-the-selected-city" },
      { label: "Gold Coast", to: "/Services/available-categories-in-the-selected-city" },
    ],
  },
];

const Footer = ({
  className = "pt-20 lg:pt-20 xl:pt-40 2xl:pt-40",
  outerBottomClassName = "pb-10",
  innerPanelPaddingClassName = "pt-10 md:pt-24 px-10 md:px-10 pb-16",
  columnsGapClassName = "gap-10 lg:gap-10 xl:gap-16 2xl:gap-16",
  listTopClassName = "mt-3",
  linkItemClassName = "mt-2",
}) => {
  const [SignUp, setSignUp] = useState(false);
  const [SignIn, setSignIn] = useState(false);
  const loginActionService = useLoginActionService();

  const [expandedMenus, setExpandedMenus] = useState(
    FOOTER_COLUMNS.reduce((acc, column) => ({ ...acc, [column.key]: false }), {})
  );

  const toggleMenu = (menu) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menu]: !prev[menu],
    }));
  };

  useEffect(() => {
    if (SignIn || SignUp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = "auto";
    }
  }, [SignIn, SignUp]);

  const renderLink = (link, index) => (
    <li key={link.label} className={index === 0 ? undefined : linkItemClassName}>
      {link.to ? (
        <Link to={link.to}>
          <Paragraph variant={"FooterParagraph"}>{link.label}</Paragraph>
        </Link>
      ) : (
        <Paragraph variant={"FooterParagraph"}>{link.label}</Paragraph>
      )}
    </li>
  );

  return (
    <>
      <footer
        className={`tp-footer-container mx-auto text-offblack ${outerBottomClassName} ${className}`}
      >
        <div
          className={`bg-brightblue text-white rounded-xl w-full mx-auto h-auto min-h-[650px] flex flex-col items-center justify-between ${innerPanelPaddingClassName}`}
        >
          <div
            className={`flex flex-wrap justify-center w-full ${columnsGapClassName} px-4 md:px-8`}
          >
            {FOOTER_COLUMNS.map((column) => (
              <div key={column.key} className="w-full md:w-auto">
                <div
                  className="flex items-center justify-between cursor-pointer md:cursor-default"
                  onClick={() => toggleMenu(column.key)}
                >
                  <SecondaryHeading variant={"FooterHeading"}>
                    {column.title}
                  </SecondaryHeading>
                  <i
                    className={`fi fi-${
                      expandedMenus[column.key] ? "sr-minus" : "rs-plus"
                    } text-base md:hidden`}
                  ></i>
                </div>
                <ul
                  className={`flex flex-col ${listTopClassName} ${
                    !expandedMenus[column.key] ? "hidden md:flex" : ""
                  }`}
                >
                  {column.links.map((link, index) => renderLink(link, index))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-20 lg:mt-5 w-full">
            <div className="flex flex-col md:flex-row items-end justify-between px-4 md:px-8 gap-6">
              <div className="w-full md:w-1/3">
                <div className="flex items-center space-x-4 mb-3">
                  <img
                    src={AboriginalFlag}
                    alt="Australian Aboriginal Flag"
                    className="w-8 h-5 object-contain"
                  />
                  <img
                    src={TorresStraitFlag}
                    alt="Torres Strait Islander Flag"
                    className="h-5 object-contain"
                  />
                </div>
                <div className="text-white">
                  <AuxiliaryText
                    variant={"Eyebrow"}
                    className={"font-bold mb-1"}
                  >
                    Acknowledgement of Country
                  </AuxiliaryText>
                  <AuxiliaryText
                    variant={"Eyebrow"}
                    className={"font-normal normal-case"}
                  >
                    Trades Poster acknowledges the Traditional Custodians of the
                    lands where we live and work across Australia. We pay respect
                    to Elders past and present.
                  </AuxiliaryText>
                </div>
              </div>

              <div className="w-full md:w-1/3 flex justify-center">
                <SpecialText variant={"FootNoteDisclaimer"}>
                  © 2026 Trades Poster. All rights reserved.
                </SpecialText>
              </div>

              <div className="w-full md:w-1/3 flex justify-center md:justify-end">
                <div className="flex items-center space-x-4">
                  <div className="flex items-center space-x-2 cursor-pointer">
                    <i className="fi fi-brands-facebook text-white text-base"></i>
                    <AuxiliaryText variant={"Eyebrow"} className={"text-white font-normal normal-case"}>Facebook</AuxiliaryText>
                  </div>
                  <div className="flex items-center space-x-2 cursor-pointer">
                    <i className="fi fi-brands-instagram text-white text-base"></i>
                    <AuxiliaryText variant={"Eyebrow"} className={"text-white font-normal normal-case"}>Instagram</AuxiliaryText>
                  </div>
                  <div className="flex items-center space-x-2 cursor-pointer">
                    <i className="fi fi-brands-tik-tok text-white text-base"></i>
                    <AuxiliaryText variant={"Eyebrow"} className={"text-white font-normal normal-case"}>TikTok</AuxiliaryText>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {SignIn && (
        <Login
          SignIn={SignIn}
          setSignIn={setSignIn}
          SignUpState={SignUp}
          setSignUpState={setSignUp}
          onLoginSuccess={() => {
            const hasPendingScenario =
              loginActionService.checkAndHandlePendingScenario(() => {});

            if (hasPendingScenario) {
              setTimeout(() => {
                setSignIn(false);
              }, 150);
            } else {
              setSignIn(false);
            }
          }}
        />
      )}

      {SignUp && (
        <SignUpRegister
          SignUpState={SignUp}
          setSignUpState={setSignUp}
          SignIn={SignIn}
          setSignIn={setSignIn}
        />
      )}
    </>
  );
};

export default Footer;
